import React from 'react';
import {
  Box,
  Grid,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

export default function CadastroTab({ notaFiscalEntrada, setNotaFiscalEntrada }) {
  // Função para atualizar campos do estado principal
  const handleChange = (field, value) => {
    setNotaFiscalEntrada((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Dados de Cadastro
      </Typography>

      <Grid container spacing={2}>
        {/* 1ª Linha */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Fornecedor"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.fornecedor || ''}
            onChange={(e) => handleChange('fornecedor', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Natureza Op."
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.naturezaOperacao || ''}
            onChange={(e) => handleChange('naturezaOperacao', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Forma Pag."
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.formaPagamento || ''}
            onChange={(e) => handleChange('formaPagamento', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Doc Fiscal"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.docFiscal || ''}
            onChange={(e) => handleChange('docFiscal', e.target.value)}
          />
        </Grid>

        {/* 2ª Linha */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Nº Documento"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.numeroDocumento || ''}
            onChange={(e) => handleChange('numeroDocumento', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Espécie"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.especieNotaFiscal || ''}
            onChange={(e) => handleChange('especieNotaFiscal', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Série"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.serieNotaFiscal || ''}
            onChange={(e) => handleChange('serieNotaFiscal', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Tipo Doc"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.tipoDocumento || ''}
            onChange={(e) => handleChange('tipoDocumento', e.target.value)}
          />
        </Grid>

        {/* 3ª Linha */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Tipo Compra"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.tipoCompra || ''}
            onChange={(e) => handleChange('tipoCompra', e.target.value)}
          />
        </Grid>

        {/* Data Atual (se for necessária) */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Data Atual"
            type="date"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={notaFiscalEntrada.dataAtual || ''}
            onChange={(e) => handleChange('dataAtual', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Chave NF-e"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.chaveNfe || ''}
            onChange={(e) => handleChange('chaveNfe', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Data Pedido"
            type="date"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={notaFiscalEntrada.dataPedido || ''}
            onChange={(e) => handleChange('dataPedido', e.target.value)}
          />
        </Grid>

        {/* 4ª Linha */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Valor Base ICMS"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorBaseIcms || ''}
            onChange={(e) => handleChange('valorBaseIcms', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Perc. ICMS"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.percIcms || ''}
            onChange={(e) => handleChange('percIcms', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Valor ICMS"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorIcms || ''}
            onChange={(e) => handleChange('valorIcms', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Valor I.P.I"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorIpi || ''}
            onChange={(e) => handleChange('valorIpi', parseFloat(e.target.value || 0))}
          />
        </Grid>

        {/* 5ª Linha */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Valor Frete"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorFrete || ''}
            onChange={(e) => handleChange('valorFrete', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Valor Frete 2"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorFrete2 || ''}
            onChange={(e) => handleChange('valorFrete2', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Valor Desconto"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorDesconto || ''}
            onChange={(e) => handleChange('valorDesconto', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Valor Seguro"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorSeguro || ''}
            onChange={(e) => handleChange('valorSeguro', parseFloat(e.target.value || 0))}
          />
        </Grid>

        {/* 6ª Linha */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Valor Outros"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorOutros || ''}
            onChange={(e) => handleChange('valorOutros', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Base Subs. Trib"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorBaseSubstituicao || ''}
            onChange={(e) => handleChange('valorBaseSubstituicao', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Base Subs. Trib 2"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorBaseSubstituicao2 || ''}
            onChange={(e) => handleChange('valorBaseSubstituicao2', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="ICMS Dispensado"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorIcmsDispensado || ''}
            onChange={(e) => handleChange('valorIcmsDispensado', parseFloat(e.target.value || 0))}
          />
        </Grid>

        {/* 7ª Linha */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Valor Total NF"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorTotalNotaFiscal || ''}
            onChange={(e) => handleChange('valorTotalNotaFiscal', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Qtd. Produtos"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.qtdProdutos || ''}
            onChange={(e) => handleChange('qtdProdutos', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Data Emissão"
            type="date"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={notaFiscalEntrada.dataEmissao || ''}
            onChange={(e) => handleChange('dataEmissao', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Data Entrada"
            type="date"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={notaFiscalEntrada.dataEntrada || ''}
            onChange={(e) => handleChange('dataEntrada', e.target.value)}
          />
        </Grid>

        {/* 8ª Linha */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Transportadora"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.transportadora || ''}
            onChange={(e) => handleChange('transportadora', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Via Transporte"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.viaTransporte || ''}
            onChange={(e) => handleChange('viaTransporte', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Vendedor"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.vendedor || ''}
            onChange={(e) => handleChange('vendedor', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Centro Custo"
            variant="outlined"
            fullWidth
            value={notaFiscalEntrada.centroCusto || ''}
            onChange={(e) => handleChange('centroCusto', e.target.value)}
          />
        </Grid>

        {/* 9ª Linha: Radio Abat. PIS/COFINS, Radio Exportar NF-e, percInss, valorInss */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="body1">Abat. PIS/COFINS:</Typography>
          <RadioGroup
            row
            value={notaFiscalEntrada.abatPisCofins ? 'Sim' : 'Não'}
            onChange={(e) => handleChange('abatPisCofins', e.target.value === 'Sim')}
          >
            <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
            <FormControlLabel value="Não" control={<Radio />} label="Não" />
          </RadioGroup>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="body1">Exportar NF-e:</Typography>
          <RadioGroup
            row
            value={notaFiscalEntrada.exportarNfe ? 'Sim' : 'Não'}
            onChange={(e) => handleChange('exportarNfe', e.target.value === 'Sim')}
          >
            <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
            <FormControlLabel value="Não" control={<Radio />} label="Não" />
          </RadioGroup>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Perc. INSS"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.percInss || ''}
            onChange={(e) => handleChange('percInss', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Valor INSS"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.valorInss || ''}
            onChange={(e) => handleChange('valorInss', parseFloat(e.target.value || 0))}
          />
        </Grid>

        {/* 10ª Linha */}
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Volume"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.volume || ''}
            onChange={(e) => handleChange('volume', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Peso Bruto"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.pesoBruto || ''}
            onChange={(e) => handleChange('pesoBruto', parseFloat(e.target.value || 0))}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Peso Líquido"
            variant="outlined"
            fullWidth
            type="number"
            value={notaFiscalEntrada.pesoLiquido || ''}
            onChange={(e) => handleChange('pesoLiquido', parseFloat(e.target.value || 0))}
          />
        </Grid>

        {/* 11ª Linha: Observações */}
        <Grid item xs={12}>
          <TextField
            label="Obs."
            variant="outlined"
            fullWidth
            multiline
            rows={2}
            value={notaFiscalEntrada.obs || ''}
            onChange={(e) => handleChange('obs', e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
